import { PermissionList } from '@/libs/defaultList'

export default [
    // *===================Accounting Report============================---*
    {
        path: '/accountingreports',
            name: 'accountingreports',
            component: () => import('@/views/reports/accountingreport/AccountingReport.vue'),
            meta: {
                pageTitle: 'Accounting Report',
                breadcrumb: [
                    {
                        text: 'Accounting Report',
                        active: true,
                    },
                ],
                permission: PermissionList.Accounting_View
            },
    }
    ]